var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-skeleton-loader',{attrs:{"loading":_vm.loading,"height":"100%","types":{ skeleton: 'list-item-avatar, divider@3,table-heading,table-tbody' },"type":"skeleton","transition":"scale-transition"}},[_c('EditUser')],1)}
var staticRenderFns = []

export { render, staticRenderFns }